import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
  Router,
  GuardResult,
  MaybeAsync,
} from '@angular/router';
import { map } from 'rxjs';
import { IdentityService, RolesEnum } from 'app/services/authentication/identity.service';

@Injectable({ providedIn: 'root' })
export class IsLoggedIn implements CanActivate {
  constructor(
    private _identityService: IdentityService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot) {
    return this._identityService.isLogged().pipe(
      map((res: boolean) => {
        if (res === true) {
          switch (this._identityService.rol) { 
            // case RolesEnum.ROLE_ADMIN:
                
            //   break;
            // case RolesEnum.ROLE_CARRIER_MAP_VIEWER:
            //   this._navigationService.navigate(RouterEnum.mapViewerCarrier);
            //   break;
            case RolesEnum.ROLE_CARRIER_ADMINISTRATIVE:
            case RolesEnum.ROLE_CARRIER_MANAGER:
            case RolesEnum.ROLE_CARRIER_OPERATOR:
            case RolesEnum.ROLE_CARRIER:
                this.router.navigate(['dashboard']);
            //   this._navigationService.navigate(RouterEnum.dashboardCarrier);
                break;
            // case RolesEnum.ROLE_CONTRACTOR_OPERATOR:
            // case RolesEnum.ROLE_CONTRACTOR_SECRETARY:
            // case RolesEnum.ROLE_CONTRACTOR_ADMINISTRATIVE:
            // case RolesEnum.ROLE_CONTRACTOR_MANAGER:
            // case RolesEnum.ROLE_CONTRACTOR:
            //   this._navigationService.navigate(RouterEnum.dashboardContractor);
            //   break;
            // case RolesEnum.ROLE_VEHICLEOWNER:
            //   this._navigationService.navigate(RouterEnum.dashboardOwner);
            //   break;
            // default:
            //     this.router.navigate(['admin/dashboard']);
            //     break;
          }
          return false;
        }
        return true;
      })
    );
  }
}


@Injectable({ providedIn: 'root' })
export class NeedLoggin implements CanActivate {
    constructor(
        private _identityService: IdentityService,
        private router: Router
    ) {}


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this._identityService.isLogged().pipe(
            map((res: boolean) => {
              if (res === false) {
                this.router.navigate(['auth/login']);
                return false;
              }
              return true;
            })
        );
    }


}